import { render } from "./ProductCard.vue?vue&type=template&id=caef6480&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=caef6480&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caef6480"]])

export default __exports__